import React, {Component , useEffect , useState , useRef } from 'react';
import ButtonGroup from "reactstrap/es/ButtonGroup";
import {Button, Col, Progress, Row, UncontrolledTooltip} from "reactstrap";
import PermissionRender, {hasAllPermissions} from "../../../../../components/PermissionRender/PermissionRender";
import {PaymentChangeType, Permissions} from "../../../../../common/Constants";
import TTLProxy from "../../../../../common/TTLAsyncProxy";
import DocumentTitle from 'react-document-title';
import {
    BankPaymentStatus,
    BasePageTemplate,
    CreateBeneficiaryView,
    ImageDisplay,
    StatusRenderer,
    Styles
} from "../Elements";
import history from '../../../../../history';
import HTML from '../../../../../common/HtmlHelpers';
import Utils, {findMediaWithTag} from "../../../../../common/Utils";
import ErrorView from "../../../../../components/Elements/ErrorView";
import LoadingView from "../../../../../components/Elements/LoadingView";
import {VirtualCredit, USSDEndpoints} from "../../../../../common/ProxyEndpoints";
import {ExpanderView, SectionedList} from "../../../../../components/AuditExplorer/Elements";
import {CustomFilterFrame} from "../../../../../components/CRUDView";
import NumberLabel from "../../../../../components/NumberLabel/NumberLabel";
import StandardValue from "../../../../../common/StandardValue";
import CurrencyLabel from "../../../../../components/CurrencyLabel/CurrencyLabel";
import DataList from "../../../../../components/TableListView/DataList";
import ImageUploadComponent from "../../../../../components/ImageUploadComponent/ImageUploadComponent";
import PropTypes from 'prop-types';
import {excludeColumns, PaymentMediaTags} from "../Common";
import Icon from 'react-icons-kit';
import {ic_edit} from 'react-icons-kit/md/ic_edit'
import {ic_book} from 'react-icons-kit/md/ic_book';
import { ic_done_all } from 'react-icons-kit/md/ic_done_all';
import { ic_check } from 'react-icons-kit/md/ic_check';
import { ic_close } from 'react-icons-kit/md/ic_close';
import { css } from "glamor";
import _ from 'lodash';
import PlaceHolderDialog from "../../../../../common/PlaceHolderDialog";
import CheckInput from "../../../../../components/CheckInput";
import CheckOptionView from "../../../../../common/CheckOptionView/CheckOptionView";
import SmartDialog from "../../../../../components/SmartDialog";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import validator from 'validator';
import MDProgress from 'react-md-progress-bar';
import {Line} from "react-chartjs-2";
import TimeAgo from "../../../../../common/TimeAgo";
import AppVariables from '../../../../../common/AppVariables';
import classnames from 'classnames';

const rowItemStyle = css({
    cursor: 'pointer'
});

const SearchViewWrapper = ({ placeholder , children , onQuery  , className }) => {

    const [search,setSearch] = useState('');

    useEffect(() => {
        onQuery();
    }, [search]);

    return <React.Fragment>

        <input className={classnames("form-control form-input",className)}
               placeholder={placeholder}
               value={search}
               onChange={evt => {
                   setSearch(evt.target.value);
               }}/>

        {children({ search })}

    </React.Fragment>

};

const PaymentTransactionsList = ({ title,  queryData , itemsPerPage = 10 }) => {

    const dataList = useRef();
    const txnInfoDlg = useRef();
    const [selectedTimeFrame,setTimeFrame] = useState(0);
    const [selectedTransaction,setSelectedTransaction] = useState(null);

    useEffect(() => {
        dataList.current.refresh();
    },[selectedTimeFrame]);

    return <div>

        <SmartDialog ref={txnInfoDlg}
                     title={"Transaction Info"}
                     showCancelButton
                     onExit={() => setSelectedTransaction(null)}>

            {selectedTransaction && <SectionedList defaultMode={"vertical"} items={[
                {
                    title: "Reference",
                    value: selectedTransaction.reference
                },
                {
                    title: "Currency",
                    value: selectedTransaction.currency
                },
                {
                    title: "Amount",
                    value: <NumberLabel value={selectedTransaction.amount}/>
                },
                {
                    title: "Customer",
                    value: `${selectedTransaction.customer_name} (${selectedTransaction.customer_phone})`
                },
                {
                    title: "Tractor Request",
                    value: <div className="p-2 font-sm ml-3">
                        <div><b>ID:</b> {selectedTransaction.tractor_request.order_id}</div>
                        <div><b>Service:</b> {selectedTransaction.tractor_request.ussd_service.name}</div>
                        <div><b>Quantity:</b> {selectedTransaction.tractor_request.hectares} {Utils.pluralize(selectedTransaction.tractor_request.hectares,selectedTransaction.tractor_request.ussd_service.unit_name)}</div>
                    </div>
                },
                {
                    title: "Time",
                    value: <TimeAgo id={"txn_time_created_" + selectedTransaction.reference} date={selectedTransaction.date_created}/>
                }
            ]}/>}

        </SmartDialog>

        <div className="clearfix">
            {title && <div className="pull-left">{title}</div>}
            <div className="pull-right">
                <select className="form-input-select"
                        value={selectedTimeFrame}
                        onChange={evt => {
                            const _value = evt.target.value;
                            setTimeFrame(_value);
                        }}>
                    {TimeRanges.map(((x,key) => (<option key={key} value={key}>{x.name}</option>)))}
                </select>
            </div>
        </div>
        <DataList columns={[
                        {
                            key: "total_amount",
                            label: "Amount",
                            render: item => <CurrencyLabel currency={item.currency} value={item.amount}/>
                        },
                        {
                            key: "customer",
                            label: "Customer",
                            render: item => `${item.customer_name} (${item.customer_phone})`
                        },
                        {
                            key: "tractor_request",
                            label: "Tractor Request",
                            render: item => {

                                return <a href="#" className="btn-link" onClick={evt => {
                                    evt.preventDefault();
                                    history.push(`/requests?q=${item.tractor_request.order_id}`);
                                }}>{item.tractor_request.ussd_service.name} - <NumberLabel value={item.tractor_request.hectares}/>  {Utils.pluralize(item.tractor_request.hectares,item.tractor_request.ussd_service.unit_name)}</a>
                            }
                        },
                        {
                            key: "total_refuned_amount",
                            label: <span><i className="fa fa-caret-down" style={{ color: "#ff0716" }}/> Refunded</span>,
                            render: item => <CurrencyLabel currency={item.currency} value={item.total_refunded_amount}/>
                        },
                        {
                            key: "date_created",
                            label: "Time",
                            render: item =>  <TimeAgo id={`payment_transaction_date_${item.id}`} date={item.date_created}/>
                        }
                    ]}
                  ref={dataList}
                  noRowsMessage={"There are no payments issued yet"}
                  onRowClick={item => {

                      setSelectedTransaction(item);
                      txnInfoDlg.current.show();

                  }}
                  defaultRowClass={`${rowItemStyle}`}
                  queryData={(page,limit) => queryData(page,limit,TimeRanges[selectedTimeFrame])}
                  itemsPerPage={itemsPerPage}
                  responsive/>
    </div>;
};

const ChangesListView = ({ payment , queryData , itemsPerPage = 10 }) => {

    const dataList = useRef();
    const [selectedTimeFrame,setTimeFrame] = useState(0);

    useEffect(() => {
        dataList.current.refresh();
    } , [selectedTimeFrame]);

    return <div>

        <div className="clearfix">
            <div className="pull-right">
                <select className="form-input-select"
                        value={selectedTimeFrame}
                        onChange={evt => {
                            const _value = evt.target.value;
                            setTimeFrame(_value);
                        }}>
                    {TimeRanges.map(((x,key) => (<option key={key} value={key}>{x.name}</option>)))}
                </select>
            </div>
        </div>

        <DataList columns={[
                        {
                            key: "amount",
                            label: "Amount",
                            render: item => <CurrencyLabel currency={payment.currency}
                                                           value={item.amount}/>
                        },
                        {
                            key: "type",
                            label: "Type",
                            render: item => {

                                switch (item.type) {
                                    case PaymentChangeType.Increment:
                                        return <span><i className="fa fa-caret-up" style={{ color: "#009e14" }}/> Increment</span>;
                                    case PaymentChangeType.Decrement:
                                        return <span><i className="fa fa-caret-down" style={{ color: "#ff0716" }}/> Decrement</span>;
                                }

                            }
                        },
                        {
                            key: "initial_amount",
                            label: "Initial Amount",
                            render: item => <CurrencyLabel currency={payment.currency}
                                                           value={item.initial_amount}/>
                        },
                        {
                            key: "final_amount",
                            label: "Final Amount",
                            render: item => <CurrencyLabel currency={payment.currency}
                                                           value={item.final_amount}/>
                        },
                        {
                            key: "created_by",
                            label: "Initiated By",
                            render: item => Utils.getUserName(item.created_by)
                        },
                        {
                            key: "date_created",
                            label: "Time",
                            render: item => <TimeAgo date={item.date_created} id={`changes_date_item_${item.id}`}/>
                        }
                    ]}
                  ref={dataList}
                  itemsPerPage={itemsPerPage}
                  noRowsMessage={"No payment changes recorded yet!"}
                  queryData={async (page,limit) => await queryData(page,limit,TimeRanges[selectedTimeFrame])}/>

    </div>;
};

const ItemGroup = ({   type ,
                       title ,
                       value ,
                       allowEdit = true,
                       formatValue,
                       validate,
                       onChange }) => {


    const [showEdit,setShowEdit] = useState(false);
    const [enableEdit,setEnableEdit] = useState(false);
    const [inputValue,setInputValue] = useState(value);
    const [error,setError] = useState(null);

    const RenderInput = ({ type , value , onChange }) => {

        switch (type) {
            case 'datetime':

                return <DatePicker selected={value ? moment(value).toDate() : value}
                                   dropdownMode={"scroll"}
                                   onChange={v => onChange(v)}/>;

            default:
                return <input onChange={evt => {
                    onChange(evt.target.value);
                }}
                              autoFocus
                              className="p-1"
                              value={value}
                              type={type || "text"}/>
        }
    };

    return <div>
        <b>{title}</b>

        <div className="clearfix"
             onMouseEnter={() => allowEdit ? setShowEdit(true) : false}
             onMouseLeave={() => setShowEdit(false)}>

            <p className={"pull-left"}>
                {enableEdit ? <RenderInput value={inputValue}
                                           onChange={value => {

                                               setInputValue(value);

                                               if(error)
                                                   setError(null);
                                           }}
                                           type={type}/>  :
                    <StandardValue value={_.isNil(value) ? null : (formatValue ? formatValue(value) : value) }/>}
            </p>

            {showEdit && !enableEdit && <Icon icon={ic_edit}
                                              className="ml-2"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                  setEnableEdit(true);
                                              }}/>}

            {enableEdit && <span className="ml-2">
                <Icon icon={ic_check}
                      size={22}
                      style={{ cursor: "pointer" , color: "#009e14" }}
                      onClick={async () => {

                          if(validate){

                              const valMsg = await validate(inputValue);
                              if(_.isString(valMsg)){
                                  setError(valMsg);
                                  return;
                              }

                          }

                          await onChange(inputValue);

                          //
                          setEnableEdit(false);
                          setError(false);
                          setShowEdit(false);

                      }}/>

                <Icon className="ml-1"
                      size={22}
                      icon={ic_close}
                      style={{ cursor: "pointer", color: "#ff1300" }}
                      onClick={() => {

                          setEnableEdit(false);
                          setError(null);

                      }}/>
            </span>}


        </div>

        {error && <div className="error-hint m-0 mb-2" >{error}</div>}

    </div>

};

const PaymentIncludeFields = [
    'created_by',
    'applicable_services',
    'media',
    'consumers'
];

const TimeRanges = [
    { name: "None" , step: { unit: "month" , value : 2 } , labelFormat: 'Do MMM YYYY' },
    { name: "Last Month", step: { unit: "week" , value : 1 } , labelFormat: 'Do MMM' , start: () => moment().subtract(1,'month').startOf('month') , end: () => moment().subtract(1,'month').endOf('month')},
    { name: "Two Months Ago" , step: { unit: "week" , value : 1 } , labelFormat: 'Do MMM' , start: () => moment().subtract(2,'month').startOf('month'), end: () => moment().subtract(2,'month').endOf('month') },
    { name: "Current Month", step: { unit: "week" , value : 1 } , labelFormat: 'Do MMM' , start: () => moment().startOf('month') , end: () => moment().endOf('month')},
    { name: "Current Week" , step: { unit: "day" , value : 1 } , labelFormat: 'Do MMM' , start: () => moment().startOf('week'), end: () => moment().endOf('week')},
    { name: "Last Week", step: { unit: "day" , value : 1 } , labelFormat: 'Do MMM' , start: () => moment().subtract(1,'week').startOf('week'), end: () => moment().subtract(1,'week').endOf('week') },
    { name: "Two Weeks Ago", step: { unit: "day" , value : 1 } , labelFormat: 'Do MMM' , start: () => moment().subtract(2,'week').startOf('week') , end: () => moment().subtract(2,'week').endOf('week') },
    { name: "Current Year", step: { unit: "month" , value : 1 } , labelFormat: 'MMM', start: () => moment().startOf('year') , end: () => moment().endOf('year')  },
    { name: "Last Year", step: { unit: "month" , value : 1 } , labelFormat: 'MMM', start: () => moment().subtract(1,'year').startOf('year') , end: () => moment().subtract(1,'year').endOf('year')  },
    { name: "Today", step: { unit: "hour" , value : 1 } , labelFormat: 'hA' , start: () => moment().startOf('day') , end: () => moment().endOf('day')},
    { name: "Yesterday" , step: { unit: "hour" , value : 1 } , labelFormat: 'hA', start: () => moment().subtract(1,'day').startOf('day'), end: () => moment().subtract(1,'day').endOf('day')},
    { name: "Last Hour" , step: { unit: "hour" , value : 1 } , labelFormat: 'hA', start: () => moment().subtract(1,'hour').startOf('hour'), end: () => moment().endOf('hour')},
    { name: "Last 5 Hours" , step: { unit: "hour" , value : 1 } , labelFormat: 'hA', start: () => moment().subtract(5,'hour').startOf('hour'), end: () => moment().endOf('hour')},
    { name: "Last 10 Hours" , step: { unit: "hour" , value : 1 } , labelFormat: 'hA', start: () => moment().subtract(10,'hour').startOf('hour'), end: () => moment().endOf('hour')},
];

class RevenueAmountChangesDialog extends Component{

    static propTypes = {
        onIncrementRevenue: PropTypes.func,
        onDecrementRevenue: PropTypes.func,
        minValue: PropTypes.number,
        maxValue: PropTypes.number
    };

    static defaultProps = {
        minValue: 1,
        maxValue: 9999999
    };

    constructor(props){
        super(props);
        this.proxy = TTLProxy.getInstance();
        this.state = RevenueAmountChangesDialog.getInitialState();
    }

    static getInitialState(state){

        return {
            payment: state ? state.payment : null,
            amount: '',
            isBusy: false,
            mode: state ? state.mode : 'increment',
            maxValue: state ? state.maxValue : null,
            minValue: state ? state.minValue : null
        };

    }

    /**
     * Show Revue
     * @param state
     */
    show(state){

        this.setState(RevenueAmountChangesDialog.getInitialState(state), () => {
            this._dlg.show()
        });

    }

    _getTitle = () => {

        const { mode } = this.state;
        switch (mode) {
            case 'increment':
                return 'Increment Revenue';
            case 'decrement':
                return 'Decrement Revenue';
        }
    };

    _computeNewTotal = (original,amount) => {

        const { mode } = this.state;
        switch (mode) {
            case 'increment':
                return original + amount;
            case 'decrement':
                return  original - amount;
        }

    };

    render(){

        let { minValue, maxValue } = this.props;
        const state = this.state;
        const payment = state.payment;
        minValue = state.minValue || minValue;
        maxValue = state.maxValue || maxValue;

        return <SmartDialog ref={r => this._dlg = r}
                            title={<span><i className="fa fa-money"/> {this._getTitle()}</span>}>

            {payment && <React.Fragment>

                <div className="clearfix">
                    <h6 className="pull-left">Amount ({payment.currency})</h6>
                    <div className="pull-right">[ Max: <b><NumberLabel value={maxValue}/></b> , Min: <b><NumberLabel value={minValue}/></b> ]</div>
                </div>
                <input className="form-control form-input p-2 font-lg"
                       placeholder="Enter amount..."
                       autoFocus
                       type="number"
                       min={minValue}
                       max={maxValue}
                       value={state.amount}
                       onChange={evt => {

                           let str = evt.target.value.trim();
                           let value = minValue;
                           if(str){
                               let _v = Number(str);
                               value = _v > maxValue ? maxValue : (_v < minValue ? minValue : _v);
                           }

                           this.setState({
                               amount: value
                           });

                       }}/>


                <div className={`${Styles.headerCardStyle} p-4 mt-4`}>

                    <div className="p-2 text-center">
                        <b>Original Amount</b>
                        <div className="font-xl" style={{ color: "#4b4b4b"}}>
                            <CurrencyLabel currency={state.payment.currency} value={state.payment.total_amount}/>
                        </div>
                    </div>

                    <div className="p-2 text-center">
                        <b><i className="fa fa-money"/> New Total Amount</b>
                        <div className="font-xl" style={{ color: "#4b4b4b"}}>
                            <i className={state.mode === "increment" ? "fa fa-caret-up" : "fa fa-caret-down"}
                               style={{ color:state.mode === "increment" ? "#009e14" : "#ff0716" }}/> <CurrencyLabel currency={state.payment.currency}
                                                                                                                     value={this._computeNewTotal(state.payment.total_amount , Number(state.amount || 0))}/>
                        </div>
                    </div>
                </div>

                <hr/>

                <MDProgress show={this.state.isBusy}/>

                <Button block
                        color="green"
                        disabled={!state.amount || state.amount === 0}
                        onClick={async () => {

                            if(window.confirm(`Confirm ${state.mode} of ${payment.currency} ${state.amount.toLocaleString('en-us',{})}?`)){

                                try{

                                    this.setState({ isBusy: true });

                                    const params = { payment, amount: state.amount };

                                    switch (this.state.mode) {
                                        case 'increment':
                                            await this.props.onIncrementRevenue(params);
                                            break;
                                        case 'decrement':
                                            await this.props.onDecrementRevenue(params);
                                            break;
                                    }

                                    //
                                    this._dlg.hide();

                                    //
                                    HTML.toastSuccess(`Operation completed successfully`);
                                }
                                catch (e) {
                                    HTML.toastError(Utils.getResponseError(e));
                                }
                                finally {
                                    this.setState({ isBusy: false });
                                }


                            }

                        }}><i className="fa fa-check"/> Confirm Payment</Button>



            </React.Fragment>}


        </SmartDialog>
    }

}

const updateProperty = (payment,propertyName,completeCallback) => {

    return async function (value) {

        if(payment[propertyName] === value)
            return;

        const proxy = TTLProxy.getInstance();

        try{

            await proxy.processRequest( VirtualCredit.updateProperty(payment.id,propertyName,value));
            return completeCallback();

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }

    };

};


class PaymentInfoComponent extends Component{

    static propTypes = {
        payment: PropTypes.any,
        verificationUsers: PropTypes.array,
        onRefresh: PropTypes.func
    };

    constructor(props){
        super(props);
        this.proxy = TTLProxy.getInstance();
        this.state = PaymentInfoComponent.getInitialState();
    }

    static getInitialState(){

        return {
            services: null
        };

    }

    /**
     * Refresh parent component
     * @param category
     * @private
     */
    _handleRefresh = async (category) => {

        await this.props.onRefresh(category);

        switch (category) {
            case 'verification_users':
                this._verificationUsersList.refresh();
                break;
            default:
                this._servicesList.refresh();
                this._beneficiaryList.refresh();
                break;
        }

    };

    render(){

        const { payment , verificationUsers } = this.props;
        const paymentEnabled = payment.enabled;
        const user = this.proxy.getUserInfo();
        const amountSpent = payment.total_amount - payment.remaining_amount;
        const remainingPercentage = (payment.remaining_amount / payment.total_amount * 100);
        const isCreator = payment.created_by_id === user.id;
        const isVerified = payment.verification_complete;
        const requiresConfirmation = !payment.verification_complete && verificationUsers.find(x => x.user_id === user.id);
        const hasConfirmed = verificationUsers.find(x => x.user_id === user.id && !_.isNil(x.date_verified));
        const allowEditing = hasConfirmed && verificationUsers.find(x => x.user_id === user.id).enable_edit && hasAllPermissions(user.permissions,[Permissions.VirtualCredit.Edit]);
        const isDisabled = !payment.enabled;

        let progressColor = '';
        if(remainingPercentage >= 70){
            progressColor = 'success';
        }
        else if(remainingPercentage >= 30 && remainingPercentage < 70){
            progressColor = 'warning';
        }
        else if(remainingPercentage < 30){
            progressColor = 'danger';
        }

        return <div>

            <PlaceHolderDialog ref={r => this._placeholderDlg = r}/>

            <div className="clearfix">

                <div className="pull-right">

                    {(payment.verification_complete && (isCreator || hasConfirmed)) && <CheckInput title={<span className="mr-2">Status: </span>}
                                                                                                   checked={paymentEnabled}
                                                                                                   style={{
                                                                                                       padding: '10px',
                                                                                                       borderRadius: '2px' ,
                                                                                                       marginBottom: '4px'
                                                                                                   }}
                                                                                                   onChange={async (evt) => {

                                                                                                       if(window.confirm(`Are you sure you want to ${ paymentEnabled ? "disable" : "enable" } this payment?`)){

                                                                                                           try {

                                                                                                               //  update payment
                                                                                                               await this.proxy.processRequest(paymentEnabled ? VirtualCredit.disablePayment(payment.id) : VirtualCredit.enablePayment(payment.id));

                                                                                                               //  refresh
                                                                                                               return this.props.onRefresh();

                                                                                                           }
                                                                                                           catch (e) {
                                                                                                               HTML.toastError(Utils.getResponseError(e));
                                                                                                           }

                                                                                                       }

                                                                                                   }}/>}

                </div>

            </div>

            <CustomFilterFrame>

                <Row>

                    <Col md={4}>

                        <div className="text-center mt-4">
                            <BankPaymentStatus payment={payment}/>
                            <p><span style={{ fontSize: "3.2em" }}><NumberLabel value={payment.total_amount}/></span> <b>{payment.currency}</b></p>
                        </div>

                    </Col>

                    <Col md={6}>
                        <ExpanderView title={<span><i className="fa fa-info-circle"/> DETAILS</span>} isExpanded>

                            <SectionedList items={[
                                {
                                    title: "Reference",
                                    value: payment.reference
                                },
                                {
                                    title: "Amount Used",
                                    value: <span><CurrencyLabel currency={payment.currency} value={amountSpent}/> - ({(amountSpent / payment.total_amount * 100).toFixed(2)}%)</span>
                                },
                                {
                                    title: "Amount Remaining",
                                    value: <span><CurrencyLabel currency={payment.currency} value={payment.remaining_amount}/> - ({remainingPercentage.toFixed(2)}%)</span>
                                }
                            ]}/>

                        </ExpanderView>
                    </Col>

                </Row>

                <div className="mt-1" style={{ display: "block"}} id={"remaining_percentage_progress"}>
                    <Progress color={progressColor}
                              value={remainingPercentage.toPrecision(2)}/>
                </div>

                <UncontrolledTooltip target={"remaining_percentage_progress"}
                                     fade={false}
                                     innerClassName={`${Styles.tooltipClass} p-2`}
                                     placement={"top"}>
                    <b>Remaining: </b><CurrencyLabel currency={payment.currency} value={payment.remaining_amount}/> - ({remainingPercentage.toFixed(0)}%)
                </UncontrolledTooltip>

            </CustomFilterFrame>

            <div className="clearfix mt-2">

                <div className="pull-right">

                    {requiresConfirmation && !hasConfirmed && <ButtonGroup className="mr-2">
                        <Button color="green" disabled={isDisabled} onClick={async () => {

                            if(window.confirm('Are you sure you want to confirm this payment?')){

                                try{

                                    const response = await this.proxy.processRequest( VirtualCredit.confirmPayment(payment.id));
                                    if(response.ok){
                                        HTML.toastMessage('Payment has been confirmed successfully');
                                        return this._handleRefresh();
                                    }

                                }
                                catch (e) {
                                    HTML.toastError(Utils.getResponseError(e));
                                }


                            }

                        }}>
                            <Icon icon={ic_done_all}/> Confirm Payment
                        </Button>
                    </ButtonGroup>}

                    <ButtonGroup>

                        {(hasConfirmed || (isCreator)) && isVerified && <Button onClick={() => {
                            this._addRevenueDlg.show({ payment: payment , mode: 'increment'});
                        }}><i className="fa fa-money"/> Add Revenue</Button>}


                        <Button onClick={() => {

                            this._placeholderDlg.show({
                                title: <span><i className="fa fa-money"/> Payment Transactions</span>,
                                large: true,
                                showCancelButton: true,
                                content: <PaymentTransactionsList queryData={async (page,limit,timeRange) => {

                                    const proxy = TTLProxy.getInstance();
                                    const response = await proxy.processRequest({
                                        ...VirtualCredit.getPaymentTransactions(payment.id),
                                        include: [
                                            'service',
                                            'tractor_request'
                                        ],
                                        filter: (!_.isNil(timeRange.start) && !_.isNil(timeRange.end)) ? [
                                            { key: "date_created" , operator: ">=" , value: timeRange.start().toJSON() , cast: "date" },
                                            { key: "date_created" , operator: "<=" , value: timeRange.end().toJSON() , cast: "date" }
                                        ] : undefined,
                                        sort: ['-date_created'],
                                        pagination: {
                                            perPage: limit,
                                            page
                                        }
                                    });

                                    return {
                                        items: response.getPayload(),
                                        count: response.getPayloadCount()
                                    };

                                }}/>
                            });

                        }}>
                            <Icon icon={ic_book}/> View Transactions
                        </Button>

                        <Button onClick={() => {



                            this._placeholderDlg.show({
                                title: <span><i className="fa fa-list"/> Payment Changes List</span>,
                                large: true,
                                showCancelButton: true,
                                content: <ChangesListView payment={payment}
                                                          queryData={async (page,limit,timeRange) => {

                                    const proxy = TTLProxy.getInstance();
                                    const response = await proxy.processRequest({
                                        ...VirtualCredit.getPaymentChangesList(payment.id),
                                        sort: ['-date_created'],
                                        include: ['created_by'],
                                        filter: (!_.isNil(timeRange.start) && !_.isNil(timeRange.end)) ? [
                                            { key: "date_created" , operator: ">=" , value: timeRange.start().toJSON() , cast: "date" },
                                            { key: "date_created" , operator: "<=" , value: timeRange.end().toJSON() , cast: "date" }
                                        ] : undefined,
                                        pagination: {
                                            perPage: limit,
                                            page
                                        }
                                    });

                                    return {
                                        items: response.getPayload(),
                                        count: response.getPayloadCount()
                                    };

                                }}/>
                            })


                        }}>
                            <i className="fa fa-list"/> Changes List
                        </Button>

                    </ButtonGroup>
                </div>

            </div>



            <Row className="mt-4">

                <Col md={6}>

                    <ExpanderView title="Creditor Info" isExpanded>

                        <div className="mt-2">

                            <Row>

                                <Col md={4}>

                                    <div className="mt-2">
                                        <ImageUploadComponent name={Utils.formatAvatarName(payment.creditor_name || "CREDITOR")}
                                                              initialImage={findMediaWithTag(payment.media,PaymentMediaTags.CreditorPhoto)}
                                                              size={84}
                                                              disabled={false}
                                                              enableChange={false}/>
                                    </div>

                                </Col>

                                <Col md={8}>
                                    <ItemGroup value={payment.creditor_name}
                                               validate={v => !v.trim() ? 'Invalid value' : null }
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'creditor_name',this._handleRefresh)}
                                               title={"Creditor Full Name"}/>

                                    <ItemGroup value={payment.creditor_phone}
                                               validate={v => !v.trim() ? 'Invalid value' : null }
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'creditor_phone',this._handleRefresh)}
                                               type={"tel"}
                                               title={"Creditor Phone No."}/>

                                    <ItemGroup value={payment.creditor_email}
                                               validate={v => v ? (!validator.isEmail(v) ? 'Invalid email' : null) : null}
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'creditor_email',this._handleRefresh)}
                                               type={"email"}
                                               title={"Creditor Email"}/>
                                </Col>

                            </Row>


                        </div>


                    </ExpanderView>

                    <ExpanderView title="Support Info" isExpanded>

                        <div className="mt-2">

                            <Row>

                                <Col md={4}>

                                    <div className="mt-2">

                                        <ImageUploadComponent name={Utils.formatAvatarName(payment.support_assistance_name || "SUPPORT")}
                                                              initialImage={findMediaWithTag(payment.media,PaymentMediaTags.SupportPhoto)}
                                                              size={84}
                                                              disabled={false}
                                                              enableChange={false}/>
                                    </div>

                                </Col>


                                <Col md={8}>

                                    <ItemGroup value={payment.support_assistance_name}
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'support_assistance_name',this._handleRefresh)}
                                               title={"Support Assistance Name"}/>

                                    <ItemGroup value={payment.support_assistance_phone}

                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'support_assistance_phone',this._handleRefresh)}
                                               type={"tel"}
                                               title={"Support Assistance Phone"}/>

                                    <ItemGroup value={payment.support_assistance_email}
                                               validate={v => v ? (!validator.isEmail(v) ? 'Invalid email' : null) : null}
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'support_assistance_email',this._handleRefresh)}
                                               type={"email"}
                                               title={"Support Assistance Email"}/>

                                </Col>

                            </Row>


                        </div>


                    </ExpanderView>

                    <br/>

                    <ExpanderView title={<span><i className="fa fa-bank"/> Bank Details</span>} isExpanded={false}>

                        <div className="mt-2">

                            <ItemGroup title="Bank Name"
                                       validate={v => !v.trim() ? 'Invalid value' : null }
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'source_name',this._handleRefresh)}
                                       value={payment.source_name}/>

                            <ItemGroup value={payment.source_branch}
                                       validate={v => !v.trim() ? 'Invalid value' : null }
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'source_branch',this._handleRefresh)}
                                       title="Branch"/>

                            <ItemGroup value={payment.source_location}
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'source_location',this._handleRefresh)}
                                       title="Physical Location / Address"/>

                            <Row>

                                <Col md={4}>
                                    <ItemGroup value={payment.date_available}
                                               formatValue={date => Utils.formatDateShort(date)}
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'date_available',this._handleRefresh)}
                                               type={"datetime"}
                                               title="Validity Date"/>
                                </Col>

                                <Col md={4}>
                                    <ItemGroup value={payment.date_issued}
                                               formatValue={date => Utils.formatDateShort(date)}
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'date_issued',this._handleRefresh)}
                                               type={"datetime"}
                                               title="Date Issued"/>
                                </Col>

                                <Col md={4}>
                                    <ItemGroup value={payment.expires_at}
                                               formatValue={date => Utils.formatDateShort(date)}
                                               allowEdit={(isCreator || allowEditing) && isVerified}
                                               onChange={updateProperty(payment,'expires_at',this._handleRefresh)}
                                               type={"datetime"}
                                               title="Expiry Date"/>
                                </Col>
                            </Row>

                            <hr/>

                            <ItemGroup value={payment.source_account_no}
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'source_account_no',this._handleRefresh)}
                                       title="Source Account No."/>

                            <ItemGroup value={payment.source_phone}
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'source_phone',this._handleRefresh)}
                                       type={"tel"}
                                       title="Bank/Branch Phone"/>

                            <ItemGroup value={payment.source_email}
                                       validate={v => v ? (!validator.isEmail(v) ? 'Invalid email' : null) : null}
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'source_email',this._handleRefresh)}
                                       type={"email"}
                                       title="Bank/Branch Email"/>


                            <h6>Bank Photo</h6>

                            <ImageDisplay height={180}
                                          src={findMediaWithTag(payment.media, PaymentMediaTags.BankPhoto)}
                                          backgroundColor={"#dfdfdf"}/>

                        </div>


                    </ExpanderView>

                    <ExpanderView title="Destination Account Info" isExpanded={false}>

                        <div className="mt-2">

                            <ItemGroup value={payment.destination_account_no}
                                       validate={v => !v.trim() ? 'Invalid value' : null }
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'destination_account_no',this._handleRefresh)}
                                       title={"Destination Account No."}/>

                            <ItemGroup value={payment.destination_account_type}
                                       validate={v => !v.trim() ? 'Invalid value' : null }
                                       allowEdit={(isCreator || allowEditing) && isVerified}
                                       onChange={updateProperty(payment,'destination_account_type',this._handleRefresh)}
                                       title={"Destination Account Type"}/>
                        </div>


                    </ExpanderView>

                    <hr/>

                    <h6><i className="fa fa-comment"/> Comments</h6>
                    <div>{payment.comments || "None"}</div>

                    <br/>

                    <b><i className="fa fa-user"/> Created By</b>
                    <p>{Utils.getUserName(payment.created_by)} ({payment.created_by.phone}) on <b>{Utils.formatDateShort(payment.date_created)}</b></p>

                </Col>

                <Col md={6}>

                    <div className="mb-4">

                        <h6><i className="fa fa-file-o"/> Document Photo</h6>
                        <ImageDisplay src={findMediaWithTag(payment.media,PaymentMediaTags.DocumentPhoto)}/>

                    </div>

                    <ExpanderView title={<span><i className="fa fa-files-o"/> Tractor Services</span>}
                                  isExpanded>

                        {(isCreator || allowEditing) && isVerified && <div className="clearfix">
                            <div className="pull-right">
                                <Button size="sm" color="green" onClick={() => {

                                    const ServiceView = ({ services , onAdd }) => {

                                        const [isBusy,setBusy] = useState(false);
                                        const [isAdding,setIsAdding] = useState(false);
                                        const [allServices,setAllServices] = useState(services);
                                        const [selectedService,setSelectedService] = useState(null);

                                        useEffect(() => {

                                            (async () => {

                                                if(Array.isArray(allServices) && allServices.length > 0){
                                                    return;
                                                }

                                                try {
                                                    setBusy(true);
                                                    const response = await this.proxy.processRequest(USSDEndpoints.getUSSDServices());
                                                    setAllServices(response.getPayload());
                                                }
                                                catch (e) {
                                                    HTML.toastError(Utils.getResponseError(e));
                                                }
                                                finally {
                                                    setBusy(false);
                                                }

                                            })();


                                        },[]);

                                        return  <div>

                                            <LoadingView isBusy={isBusy}>

                                                <div className="p-2 mb-2" style={{ backgroundColor: "#e2e2e2"}}>
                                                    <span><b>Note:</b> Service cannot be removed after inclusion. Service can only be disabled to prevent its effect</span>
                                                </div>


                                                <h6 className="mb-2">Service</h6>
                                                <Select name={"service"}
                                                        value={selectedService}
                                                        placeholder={"Select service to be included..."}
                                                        isOptionDisabled={option => option.disabled}
                                                        onChange={value => {
                                                            setSelectedService(value);
                                                        }}
                                                        options={(allServices || []).map(x => ({
                                                            label: x.name ,
                                                            value: x.id ,
                                                            instance: x,
                                                            disabled: payment.applicable_services.find(t => t.service_id === x.id)
                                                        }))}/>
                                                <hr/>

                                                <MDProgress show={isAdding}/>

                                                <Button color="green"
                                                        block
                                                        onClick={async () => {

                                                            //
                                                            setIsAdding(true);
                                                            await onAdd(selectedService.value);
                                                            setIsAdding(false);

                                                        }}
                                                        disabled={selectedService === null}>
                                                    <i className="fa fa-plus"/> Add Service
                                                </Button>


                                            </LoadingView>
                                        </div>

                                    };

                                    this._placeholderDlg.show({
                                        title: "Add Service",
                                        content: <ServiceView services={this.state.services}
                                                              onAdd={async service => {

                                                                  try {

                                                                      await this.proxy.processRequest(VirtualCredit.addPaymentUSSDService(payment.id,{
                                                                          service_id: service,
                                                                          price_binding: null,
                                                                          comments: null,
                                                                          enabled: true
                                                                      }));


                                                                      this._placeholderDlg.hide();
                                                                      HTML.toastSuccess('Service inclusion completed successfully');
                                                                      return  this._handleRefresh();
                                                                  }
                                                                  catch (e) {
                                                                      console.log(e);
                                                                      HTML.toastError(Utils.getResponseError(e));
                                                                  }


                                                              }}/>
                                    });

                                }}><i className="fa fa-plus"/> Add Service</Button>
                            </div>
                        </div>}

                        <DataList columns={excludeColumns([
                            {
                                key: "name",
                                label: "Name",
                                render: item => item.service.name
                            },
                            {
                                key: "status",
                                label: "Status",
                                render:  item => <StatusRenderer enabled={item.enabled}
                                                                 onChange={async () => {

                                                                     try {
                                                                         await this.proxy.processRequest(VirtualCredit.changeUSSDServiceStatus(item.id,!item.enabled));
                                                                         return this._handleRefresh();
                                                                     }
                                                                     catch (e) {
                                                                         HTML.toastError(Utils.getResponseError(e));
                                                                     }

                                                                 }}
                                                                 confirmMessage={() => `Are you sure you want to ${!item.enabled ? 'enable' : 'disable'} service?`}/>
                            }], (!isCreator && allowEditing) ? ['status'] : null)}
                                  itemsPerPage={5}
                                  listRef={r => this._servicesList = r}
                                  data={payment.applicable_services}/>

                    </ExpanderView>

                    <ExpanderView title={<span><i className="fa fa-user"/> Beneficiaries</span>}
                                  isExpanded>

                        {(isCreator || allowEditing) && isVerified && <div className="clearfix">
                            <div className="pull-right">
                                <Button size="sm" color="green" onClick={() => {

                                    this._placeholderDlg.show({
                                        title: <span><i className="fa fa-user-plus"/> Add Beneficiary</span>,
                                        showCancelButton: false,
                                        content: <CreateBeneficiaryView currency={payment.currency}
                                                                        totalAmount={payment.total_amount}
                                                                        beneficiaries={payment.consumers.map(t => t.associated_farmer)}
                                                                        remainingAmount={payment.total_amount - _.sumBy(payment.consumers,x => x.max_amount)}
                                                                        onSubmit={async values => {

                                                                            const payload = {
                                                                                name: Utils.getUserName(values.farmer.instance),
                                                                                phone: values.farmer.instance.phone,
                                                                                email: values.farmer.instance.email,
                                                                                max_amount: values.max_amount,
                                                                                associated_farmer_id: values.farmer.instance.id,
                                                                                reference: {
                                                                                    mode: values.reference_mode,
                                                                                    value: values.passport_id || values.voters_id || values.national_id || values.drivers_id || values.farmer.instance.phone
                                                                                },
                                                                                comments: values.comments || null
                                                                            };

                                                                            //
                                                                            try {

                                                                                //  process request
                                                                                await this.proxy.processRequest( VirtualCredit.addPaymentConsumer(payment.id,payload) );

                                                                                //  hide dialog
                                                                                this._placeholderDlg.hide();

                                                                                //
                                                                                HTML.toastSuccess('Beneficiary added successfully');

                                                                                //
                                                                                return this._handleRefresh();

                                                                            }
                                                                            catch (e) {
                                                                                HTML.toastError(Utils.getResponseError(e));
                                                                            }




                                                                        }}/>
                                    });

                                }}><i className="fa fa-plus"/> Add Beneficiary</Button>
                            </div>
                        </div>}

                        <SearchViewWrapper placeholder={"Search beneficiaries..."}
                                           className="mt-2"
                                           onQuery={() => this._beneficiaryList.refresh()}>

                            {({ search }) => <DataList itemsPerPage={5}
                                                       noRowsMessage={"No beneficiaries match current filter or search keyword"}
                                                       queryData={(page,limit, { paginate }) => {

                                                           const items = search.trim().length > 0 ? paginate(payment.consumers.filter(x => Utils.containsText(x.name,search) ||
                                                               Utils.containsText(x.phone,search) ||
                                                               Utils.containsText(x.passport_id,search) ||
                                                               Utils.containsText(x.drivers_id,search) ||
                                                               Utils.containsText(x.national_id,search) ||
                                                               Utils.containsText(x.voters_id,search) ||
                                                               Utils.containsText(x.max_amount.toString(),search) ||
                                                               (x.farmer ? Utils.containsText(x.farmer.phone,search) : false) ),page,limit) : payment.consumers;

                                                           return {
                                                               items: items,
                                                               count: items.length === 0 ? 0 : payment.consumers.length
                                                           };

                                                       }}
                                                       defaultRowClass={`${rowItemStyle}`}
                                                       listRef={r => this._beneficiaryList = r}
                                                       onRowClick={item => {

                                                           const ConsumerStatisticsView = ({ payment, consumer }) => {

                                                               const [isBusy,setIsBusy] = useState(false);
                                                               const [error,setError] = useState(null);
                                                               const [summary,setSummary] = useState({
                                                                   totalConsumed: 0,
                                                                   totalRefunded: 0,
                                                                   totalAllocated: 0,
                                                                   currency: ''
                                                               });

                                                               useEffect(() => {

                                                                   (async function run() {

                                                                       const proxy = TTLProxy.getInstance();

                                                                       try{
                                                                           setIsBusy(true);
                                                                           setError(null);
                                                                           const response = await proxy.processRequest( VirtualCredit.getConsumerTransactionSummary(consumer.associated_farmer_id) );
                                                                           setSummary(response.getPayload());
                                                                       }
                                                                       catch (e) {
                                                                           setError(e);
                                                                       }
                                                                       finally {
                                                                           setIsBusy(false);
                                                                       }

                                                                   })();


                                                               },[]);

                                                               return <CustomFilterFrame>
                                                                   <b className="font-xl">{consumer.associated_farmer.name}</b>
                                                                   <SectionedList defaultMode={"horizontal"}
                                                                                  items={[
                                                                                      {
                                                                                          title: "Total Amount Utilized",
                                                                                          value: <CurrencyLabel currency={summary.currency}
                                                                                                                value={summary.totalConsumed}/>
                                                                                      },
                                                                                      {
                                                                                          title: "Total Amount Refunded",
                                                                                          value: <CurrencyLabel currency={summary.currency}
                                                                                                                value={summary.totalRefunded}/>
                                                                                      },
                                                                                      {
                                                                                          title: "Remaining Amount",
                                                                                          value: <CurrencyLabel currency={summary.currency}
                                                                                                                value={summary.totalAllocated - summary.totalConsumed}/>
                                                                                      },
                                                                                      {
                                                                                          title: "Total Allocated Amount",
                                                                                          value: <CurrencyLabel currency={summary.currency}
                                                                                                                value={summary.totalAllocated}/>
                                                                                      }
                                                                                  ]}/>
                                                               </CustomFilterFrame>

                                                           };

                                                           const ConsumerSpendingChart = ({ payment , consumer }) => {

                                                               const [isBusy,setIsBusy] = useState(false);
                                                               const [error,setError] = useState(null);
                                                               const [selectedTimeFrame,setTimeFrame] = useState(0);

                                                               const [chartData,setChartData] = useState({
                                                                   time_frame: '',
                                                                   active: [],
                                                                   cancelled: [],
                                                                   refunded: []
                                                               });

                                                               useEffect(() => {

                                                                   (async function () {

                                                                       const proxy = TTLProxy.getInstance();

                                                                       try {
                                                                           setIsBusy(true);
                                                                           setError(null);

                                                                           const _timeFrame = TimeRanges[selectedTimeFrame];
                                                                           const response = await proxy.processRequest( VirtualCredit.getConsumerSpendChart(
                                                                               consumer.associated_farmer_id,
                                                                               'custom',
                                                                               {
                                                                                   min: (_timeFrame.start ? _timeFrame.start() : moment().startOf('year').add(-2,"years") ).toJSON(),
                                                                                   max: (_timeFrame.end ? _timeFrame.end() : moment().endOf('year') ).toJSON()
                                                                               },
                                                                               `${_timeFrame.step.value},${_timeFrame.step.unit}`));

                                                                           setChartData(response.getPayload());
                                                                       }
                                                                       catch (e) {
                                                                           setError(e);
                                                                       }
                                                                       finally {
                                                                           setIsBusy(false);
                                                                       }

                                                                   })();

                                                               }, [selectedTimeFrame]);

                                                               const data = {
                                                                   labels: chartData.active.map((i) => moment(i.time).format(TimeRanges[selectedTimeFrame].labelFormat || 'MMM')),
                                                                   datasets: [

                                                                       //    active set
                                                                       {
                                                                           label: `Spent (${AppVariables.CurrencyCode})`,
                                                                           fill: true,
                                                                           lineTension: 0.1,
                                                                           backgroundColor: 'rgba(75,192,192,0.4)',
                                                                           borderColor: 'rgba(75,192,192,1)',
                                                                           borderCapStyle: 'butt',
                                                                           borderDash: [],
                                                                           borderDashOffset: 0.0,
                                                                           borderJoinStyle: 'miter',
                                                                           pointBorderColor: 'rgba(75,192,192,1)',
                                                                           pointBackgroundColor: '#fff',
                                                                           pointBorderWidth: 1,
                                                                           pointHoverRadius: 5,
                                                                           pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                                                                           pointHoverBorderColor: 'rgba(220,220,220,1)',
                                                                           pointHoverBorderWidth: 2,
                                                                           pointRadius: 1,
                                                                           pointHitRadius: 10,
                                                                           data: chartData.active.map((i) => i.peak)
                                                                       },

                                                                       //    refunded set
                                                                       {
                                                                           label: `Refunded (${AppVariables.CurrencyCode})`,
                                                                           fill: false,
                                                                           lineTension: 0.1,
                                                                           backgroundColor: 'rgba(192,128,0,0.4)',
                                                                           borderColor: 'rgb(192,187,2)',
                                                                           borderCapStyle: 'butt',
                                                                           borderDash: [],
                                                                           borderDashOffset: 0.0,
                                                                           borderJoinStyle: 'miter',
                                                                           pointBorderColor: 'rgb(192,174,12)',
                                                                           pointBackgroundColor: '#fff',
                                                                           pointBorderWidth: 1,
                                                                           pointHoverRadius: 5,
                                                                           pointHoverBackgroundColor: 'rgb(192,162,0)',
                                                                           pointHoverBorderColor: 'rgba(220,220,220,1)',
                                                                           pointHoverBorderWidth: 2,
                                                                           pointRadius: 1,
                                                                           pointHitRadius: 10,
                                                                           data: chartData.refunded.map((i) => i.peak)
                                                                       },

                                                                       //    cancelled set
                                                                       {
                                                                           label: `Cancelled (${AppVariables.CurrencyCode})`,
                                                                           fill: false,
                                                                           lineTension: 0.1,
                                                                           backgroundColor: 'rgba(255,7,22,0.4)',
                                                                           borderColor: 'rgba(255,7,22,1)',
                                                                           borderCapStyle: 'butt',
                                                                           borderDash: [],
                                                                           borderDashOffset: 0.0,
                                                                           borderJoinStyle: 'miter',
                                                                           pointBorderColor: 'rgb(255,7,22)',
                                                                           pointBackgroundColor: '#fff',
                                                                           pointBorderWidth: 1,
                                                                           pointHoverRadius: 5,
                                                                           pointHoverBackgroundColor: 'rgb(255,7,22)',
                                                                           pointHoverBorderColor: 'rgba(220,220,220,1)',
                                                                           pointHoverBorderWidth: 2,
                                                                           pointRadius: 1,
                                                                           pointHitRadius: 10,
                                                                           data: chartData.cancelled.map((i) => i.peak)
                                                                       }
                                                                   ]};

                                                               return <div>

                                                                   <div className="clearfix">
                                                                       <div className="pull-right">
                                                                           <select className="form-input-select" onChange={evt => {
                                                                               setTimeFrame(evt.target.value);
                                                                           }}>
                                                                               {TimeRanges.map((t,key) => <option key={key} value={key}>{t.name}</option>)}
                                                                           </select>
                                                                       </div>
                                                                       {selectedTimeFrame > 0 && <div className="pull-left">
                                                                           Showing transaction(s) for <b>{TimeRanges[selectedTimeFrame].name.toLowerCase()}</b>
                                                                       </div>}
                                                                   </div>

                                                                   <div style={{ maxHeight: 240 }}>
                                                                       <Line data={data}
                                                                             height={240}
                                                                             options={{maintainAspectRatio: false }} />
                                                                   </div>
                                                               </div>

                                                           };

                                                           const ActionsView = ({ payment , consumer , onRefresh }) => {

                                                               const revenueDialog = useRef();
                                                               const actionDlg = useRef();

                                                               return <div className="clearfix">

                                                                   <PlaceHolderDialog ref={actionDlg}/>

                                                                   <RevenueAmountChangesDialog ref={revenueDialog}
                                                                                               onIncrementRevenue={async ({ payment , amount }) => {

                                                                                                   const proxy = TTLProxy.getInstance();
                                                                                                   await proxy.processRequest( VirtualCredit.allocatePaymentConsumer(consumer.id,{
                                                                                                       amount,
                                                                                                       comments: null
                                                                                                   }));

                                                                                                   //
                                                                                                   onRefresh();

                                                                                               }}
                                                                                               onDecrementRevenue={async ({ payment , amount })=> {

                                                                                                   const proxy = TTLProxy.getInstance();
                                                                                                   await proxy.processRequest( VirtualCredit.deallocatePaymentConsumer(consumer.id,{
                                                                                                       amount,
                                                                                                       comments: null
                                                                                                   }));

                                                                                                   //
                                                                                                   onRefresh();

                                                                                               }}/>

                                                                   <div className="pull-right">
                                                                       <ButtonGroup>

                                                                           <Button onClick={() => revenueDialog.current.show({ payment , mode: "increment" , maxValue: payment.total_amount - _.sumBy(payment.consumers,x => Number(x.max_amount)) })}><i className="fa fa-plus" style={{ color: "#009e14" }}/> Increment Revenue</Button>

                                                                           <Button onClick={() => {
                                                                               revenueDialog.current.show({ payment , mode: "decrement", maxValue: consumer.max_amount - consumer.amount_spent });
                                                                           }}><i className="fa fa-minus" style={{ color: "#ff0716" }}/> Decrement Revenue</Button>

                                                                           <Button onClick={() => {

                                                                               actionDlg.current.show({
                                                                                   title: <span><i className="fa fa-list"/> Revenue Changes</span>,
                                                                                   large: true,
                                                                                   showCancelButton: true,
                                                                                   content: <ChangesListView payment={payment}
                                                                                                             itemsPerPage={5}
                                                                                                             queryData={async (page,limit,timeRange) => {

                                                                                                                 const proxy = TTLProxy.getInstance();
                                                                                                                 const response = await proxy.processRequest({
                                                                                                                     ...VirtualCredit.getPaymentConsumerChangesList(consumer.id),
                                                                                                                     sort: ['-date_created'],
                                                                                                                     include: ['created_by'],
                                                                                                                     filter: (!_.isNil(timeRange.start) && !_.isNil(timeRange.end)) ? [
                                                                                                                         { key: "date_created" , operator: ">=" , value: timeRange.start().toJSON() , cast: "date" },
                                                                                                                         { key: "date_created" , operator: "<=" , value: timeRange.end().toJSON() , cast: "date" }
                                                                                                                     ] : undefined,
                                                                                                                     pagination: {
                                                                                                                         perPage: limit,
                                                                                                                         page
                                                                                                                     }
                                                                                                                 });

                                                                                                                 return {
                                                                                                                     items: response.getPayload(),
                                                                                                                     count: response.getPayloadCount()
                                                                                                                 };

                                                                                                             }}/>
                                                                               })

                                                                           }}><i className="fa fa-list"/> Revenue Changes</Button>

                                                                       </ButtonGroup>
                                                                   </div>

                                                               </div>;

                                                           };

                                                           this._placeholderDlg.show({
                                                               title: <span><i className="fa fa-money"/> Payment Transactions</span>,
                                                               large: true,
                                                               showCancelButton: true,
                                                               content: <div>

                                                                   <div className="mb-2">

                                                                       <ConsumerStatisticsView payment={payment}
                                                                                               consumer={item}/>

                                                                       <ActionsView payment={payment}
                                                                                    consumer={item}
                                                                                    onRefresh={() => {
                                                                                        this._placeholderDlg.hide();
                                                                                        return this._handleRefresh();
                                                                                    }}/>


                                                                       <hr/>

                                                                   </div>

                                                                   <PaymentTransactionsList itemsPerPage={5}
                                                                                            title={<h5>Payment Transactions</h5>}
                                                                                            queryData={async (page,limit,timeRange) => {

                                                                                                const proxy = TTLProxy.getInstance();
                                                                                                const response = await proxy.processRequest({
                                                                                                    ...VirtualCredit.getPaymentTransactionForConsumer(item.associated_farmer_id),
                                                                                                    sort: ['-date_created'],
                                                                                                    include: [
                                                                                                        'service',
                                                                                                        'tractor_request'
                                                                                                    ],
                                                                                                    filter: (!_.isNil(timeRange.start) && !_.isNil(timeRange.end)) ? [
                                                                                                        { key: "date_created" , operator: ">=" , value: timeRange.start().toJSON() , cast: "date" },
                                                                                                        { key: "date_created" , operator: "<=" , value: timeRange.end().toJSON() , cast: "date" }
                                                                                                    ] : undefined,
                                                                                                    pagination: {
                                                                                                        perPage: limit,
                                                                                                        page
                                                                                                    }
                                                                                                });

                                                                                                return {
                                                                                                    items: response.getPayload(),
                                                                                                    count: response.getPayloadCount()
                                                                                                };

                                                                                            }}/>

                                                                   <hr/>

                                                                   <div className="mt-2">
                                                                       <ConsumerSpendingChart payment={payment}
                                                                                              consumer={item}/>
                                                                   </div>

                                                               </div>
                                                           });

                                                       }}
                                                       columns={excludeColumns([
                                                           {
                                                               key: "name",
                                                               label: "Name",
                                                           },
                                                           {
                                                               key: "identity",
                                                               label: "Identity",
                                                               render: item => {

                                                                   switch (item.reference_mode) {
                                                                       case "phone_number":
                                                                           return item.phone;
                                                                       case "passport":
                                                                           return item.passport_id;
                                                                       case "drivers_license":
                                                                           return  item.drivers_id;
                                                                       case "national_id":
                                                                           return item.national_id;
                                                                       case "voters_id":
                                                                           return item.voters_id;
                                                                   }
                                                               }
                                                           },
                                                           {
                                                               key: "max_amount",
                                                               label: "Amount",
                                                               render: item => <CurrencyLabel currency={payment.currency} value={item.max_amount}/>
                                                           },
                                                           {
                                                               key: "status",
                                                               label: "Status",
                                                               render:  item => <StatusRenderer enabled={item.enabled}
                                                                                                onChange={async () => {

                                                                                                    try {
                                                                                                        await this.proxy.processRequest(VirtualCredit.changeConsumerStatus(item.id,!item.enabled));
                                                                                                        return this._handleRefresh();
                                                                                                    }
                                                                                                    catch (e) {
                                                                                                        HTML.toastError(Utils.getResponseError(e));
                                                                                                    }

                                                                                                }}
                                                                                                confirmMessage={() => `Are you sure you want to ${!item.enabled ? 'enable' : 'disable'} beneficiary?`}/>

                                                           }
                                                       ], (!isCreator && allowEditing) ? ['status'] : null)}/>}
                        </SearchViewWrapper>

                    </ExpanderView>

                    <hr/>

                    <ExpanderView title={<span><i className="fa fa-users"/> Users (Payment Verification)</span>}
                                  isExpanded>


                        <div className={`${Styles.headerCardStyle} p-2`} style={{ backgroundColor: "#efefef" }}>
                            <p className="text-center mt-3">
                                <b>{verificationUsers.filter(x => !_.isNil(x.date_verified)).length}</b> OF <b>{verificationUsers.length}</b> USERS CONFIRMED PAYMENT
                            </p>
                        </div>

                        <DataList itemsPerPage={5}
                                  data={verificationUsers}
                                  defaultRowClass={`${rowItemStyle}`}
                                  listRef={r => this._verificationUsersList = r}
                                  onRowClick={item => { }}
                                  columns={excludeColumns([
                                      {
                                          key: "name",
                                          label: "Name",
                                          render: item => Utils.getUserName(item.user)
                                      },
                                      {
                                          key: "verified",
                                          label: "Verification",
                                          render: item => {
                                              return item.date_verified ? <span><i className="fa fa-check" style={{ color: "#00c157" }}/> Verified</span> : "NOT VERIFIED"
                                          }
                                      },
                                      {
                                          key: "status",
                                          label: "Allow Editing",
                                          render: item => <StatusRenderer enabled={item.enable_edit}
                                                                          onChange={async () => {

                                                                              try {

                                                                                  await this.proxy.processRequest(VirtualCredit.changeVerificationUserStatus(item.id,!item.enable_edit));
                                                                                  return this._handleRefresh('verification_users');
                                                                              }
                                                                              catch (e) {
                                                                                  HTML.toastError(Utils.getResponseError(e));
                                                                              }

                                                                          }}
                                                                          confirmMessage={() => !item.enable_edit ? 'Grant payment edit access to user' : 'Revoke payment edit access for user'}/>
                                      }
                                  ],  (!isCreator && allowEditing) ? ['status'] : null)}/>

                    </ExpanderView>


                    <br/>

                </Col>

            </Row>

            <RevenueAmountChangesDialog ref={r => this._addRevenueDlg = r}
                              onIncrementRevenue={({ payment,  amount })=> this.proxy.processRequest(VirtualCredit.addPaymentAmount(payment.id,amount))}
                              onRevenueAdded={() => this._handleRefresh()}/>

        </div>
    }

}

/**
 * Payment Detail
 */
class PaymentDetail extends Component{

    constructor(props) {
        super(props);

        this.state = {
            isBusy: false,
            error: null,
            payment: null,
            verificationUsers: null,
            transactions: null
        };

        this.proxy = TTLProxy.getInstance();
        this.loadState = this.loadState.bind(this);
    }

    componentDidMount() {

        //  load state
        return this.loadState();

    }

    async _getPayment(id){

        const response = await this.proxy.processRequest({
            ...VirtualCredit.getPayment(id),
            include: PaymentIncludeFields
        });

        return response.getPayload();
    }

    async _getVerificationUsers(id){
        const response = await this.proxy.processRequest(VirtualCredit.getVerificationUsers(id));
        return response.getPayload();
    }

    async loadState(){

        const id = this.props.match.params.id;
        const proxy = this.proxy;

        try {

            this.setState({
                isBusy: true,
                error: null
            });

            const [payment,verificationUsers] = await Promise.all([

                //  payment
                this._getPayment(id),

                //  verification users
                this._getVerificationUsers(id)
            ]);

            this.setState({
                payment: payment,
                verificationUsers: verificationUsers
            });

        }
        catch (e) {

            //
            HTML.toastError(Utils.getResponseError(e));

            this.setState({
                error: e
            });

        }
        finally {

            this.setState({
                isBusy: false
            });

        }


    }

    render() {

        const { error, isBusy , verificationUsers } = this.state;

        return (<DocumentTitle title="Yolum - Payment Details">

            <BasePageTemplate title={<span><i className="fa fa-credit-card"/> Yolum Payment Info</span>}
                              onClose={() => history.push('/finance/credit/virtual/payments')}>

                <LoadingView isBusy={isBusy}
                             message={"Fetching payment info, please hold on..."}>

                    <ErrorView error={error}
                               retryCallback={() => this.loadState()}>

                        {this.state.payment && <PaymentInfoComponent verificationUsers={verificationUsers}
                                                                     onRefresh={async (category) => {

                                                                         switch (category) {
                                                                             case 'verification_users':{

                                                                                 this.setState({
                                                                                     verificationUsers: await this._getVerificationUsers(this.state.payment.id)
                                                                                 });

                                                                             }break;
                                                                             default:{

                                                                                 this.setState({
                                                                                     payment: await this._getPayment(this.state.payment.id)
                                                                                 });

                                                                             }
                                                                         }


                                                                     }}
                                                                     payment={this.state.payment}/>}
                    </ErrorView>

                </LoadingView>

            </BasePageTemplate>

        </DocumentTitle>);
    }

}

export default PaymentDetail;



// WEBPACK FOOTER //
// ./src/views/Extras/Finance/VirtualCredit/PaymentDetail/PaymentDetail.js